import { Zone, ZonePopulation } from '../../domain/entities/zone';

import { asRecord, readArray, readId, readString } from './raw-json';

function toZonePopulation(raw: unknown): ZonePopulation | null {
  const record = asRecord(raw);
  const id = readId(record);
  const name = readString(record, 'name', 'title', 'label');

  if (id === null || name === null) {
    return null;
  }
  return { id, name };
}

export function toZone(raw: unknown): Zone | null {
  const record = asRecord(raw);
  const id = readId(record);
  const name = readString(record, 'name', 'title', 'label');

  if (id === null || name === null) {
    return null;
  }

  return {
    id,
    name,
    populations: readArray(record, 'populations', 'poblaciones')
      .map(toZonePopulation)
      .filter((population): population is ZonePopulation => population !== null),
  };
}
